module.exports = __webpack_public_path__ + "static/img/Send11.e8c5a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send11.png
// module id = PCX1
// module chunks = 0